import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';

const Footer = (props) => {

    if (!props.isDisplayFooter) {
        return null;
    }

    return (
        <footer className={`premium-packages-catalog-footer  ${props.isStickyMobile ? 'sticky' : ''}`}>
            <div className={`premium-packages-catalog-footer-wrapper`}>
                <div className='premium-packages-catalog-footer-error'>{props.errorText}</div>
                <BtnSubmit
                    isBusiness={false}
                    text={props.btnText}
                    onclick={props.onclick}
                    formid={props.formid}
                    isDisplayArrows={props.isDisplayArrows}
                />
            </div>
        </footer>
    );
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
